import { EmptyState } from '../components/EmptyState.js';

export function AnalyticsPage() {
  return (
    <EmptyState
      title="Analytics"
      body="Per-installation dashboards (review volume, time-to-merge, etc.) land in a follow-up plan."
    />
  );
}